import { render, staticRenderFns } from "./TherapistProfile.vue?vue&type=template&id=216abfa6&scoped=true"
import script from "./TherapistProfile.vue?vue&type=script&lang=js"
export * from "./TherapistProfile.vue?vue&type=script&lang=js"
import style0 from "./TherapistProfile.vue?vue&type=style&index=0&id=216abfa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216abfa6",
  null
  
)

export default component.exports